// >>> PLENARIUM:INSTALAR_APP
// Botao "Instalar aplicativo" das telas de login. So aparece em celular
// e tablet, e some quando o app ja esta instalado.
// O pedido de instalacao do navegador e guardado no index.html (ele chega
// antes desta tela existir) em window.__pedidoInstalacao.
import React, { useEffect, useState } from 'react';
import { Download } from 'lucide-react';

const jaInstalado = () =>
  (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
  window.navigator.standalone === true;

const ehApple = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iPad novo se diz "Mac"

const ehMovel = () => /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent) || ehApple();

export default function InstalarApp() {
  const [pedido, setPedido] = useState(() => window.__pedidoInstalacao || null);
  const [instalado, setInstalado] = useState(jaInstalado);

  useEffect(() => {
    const disponivel = () => setPedido(window.__pedidoInstalacao || null);
    const pronto = () => { setInstalado(true); setPedido(null); };
    window.addEventListener('plenarium-instalavel', disponivel);
    window.addEventListener('appinstalled', pronto);
    return () => {
      window.removeEventListener('plenarium-instalavel', disponivel);
      window.removeEventListener('appinstalled', pronto);
    };
  }, []);

  if (instalado || !ehMovel()) return null;

  const instalar = async () => {
    const p = pedido;
    if (!p) return;
    try {
      p.prompt();
      const escolha = await p.userChoice;
      if (escolha && escolha.outcome === 'accepted') setInstalado(true);
    } catch (e) { /* o navegador recusou: segue com a instrucao */ }
    window.__pedidoInstalacao = null;
    setPedido(null);
  };

  const caixa = { marginTop: 16, padding: '12px 14px', borderRadius: 10, background: 'rgba(37,99,235,0.08)', border: '1px solid rgba(37,99,235,0.25)', textAlign: 'center' };
  const dica = { fontSize: '0.8rem', color: 'var(--texto-suave)', margin: 0, lineHeight: 1.5 };

  if (pedido) {
    return (
      <div style={caixa}>
        <button type="button" className="btn btn-primary" onClick={instalar} style={{ width: '100%', justifyContent: 'center' }}>
          <Download size={16} /> Instalar aplicativo
        </button>
        <p style={{ ...dica, marginTop: 8 }}>Coloca o Plenarium na tela inicial do aparelho.</p>
      </div>
    );
  }

  return (
    <div style={caixa}>
      <p style={{ ...dica, fontWeight: 700, color: 'inherit', marginBottom: 4 }}>Instalar o aplicativo</p>
      <p style={dica}>
        {ehApple()
          ? <>No Safari, toque em <strong>Compartilhar</strong> e depois em <strong>Adicionar à Tela de Início</strong>.</>
          : <>Abra o menu <strong>⋮</strong> do navegador e toque em <strong>Adicionar à tela inicial</strong> ou <strong>Instalar app</strong>.</>}
      </p>
    </div>
  );
}
// <<< PLENARIUM:INSTALAR_APP
